import { apiClient } from "@/services/api/axiosClient";
import type { DashboardData } from "./dashboardTypes";
import type { ApiResponse } from "@/services/api/api.types";

export const getDashboardDataApi = async (): Promise<DashboardData> => {
  const response = await apiClient.get<ApiResponse<DashboardData>>("/dashboard");
  return response.data.data;
};
